import { FileMetaData, ImagePreview, PreviewContainer, RemoveFileIcon, ShowContent } from "components/Common/file-upload/file-upload.styles";
import { SuccessOk } from "configs/statusCode";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
    Col, Row, Modal, ModalBody, ModalHeader,
} from "reactstrap";

const ConfirmReceiptModal = ({modal, setModal,price, form,setShouldGetData, dealId, Service}) => {
    const [loading, setLoading] = useState(false)
    const [formState, setFormState] = useState({
        media_id: '',
        media_id_path: '',
        status: ''
    })

    useEffect(()=>{
        if(!!form?.media){
            setFormState({...formState, media: form?.media, status: form?.status})
        }
    }, [form?.media])
    
    const SubmitHandler = () => {
        setLoading(true)
        Service.submitRecepit(dealId).then(res => {
            if (res && res.status === SuccessOk) {
                toast.success("Receipt Submit Successfully")
                setShouldGetData(true)
                setModal(false)
                setLoading(false)
            }
        })
    }

    const notSubmit = () =>{
        setLoading(true)
        Service.notSubmitRecepit(dealId).then(res => {
            if (res && res.status === SuccessOk) {
                toast.success("Receipt Not Submit Successfully")
                setModal(false)
                setShouldGetData(true)
                setLoading(false)
            }
        })
    }

    return (
        <Modal
                    isOpen={modal}
                    toggle={() => setModal(false)}
                    style={{ maxWidth: '500px', marginTop: "6%", width: '100%' }}
                    className="ar-wrapper"
                >
                    <ModalHeader toggle={() => setModal(false)}>
              </ModalHeader>
                    <ModalBody>

                        <Row>
                            <Col md={12} className='text-start'>
                                <label className="font-size-16 mb-1 fw-bold">Price</label>
                                <p className="font-size-18 text-start fw-bold">{toCurrency(price)}</p>
                            </Col>
                            <Col md={12}>
                            <PreviewContainer className="m-auto w-75 mb-5" style={{height: '250px'}}>
                                <div >
                                <ImagePreview
                                
                                    src={formState.media?.path}
                                    alt={`file preview`}
                                />

                                <FileMetaData>
                                    <aside>
                                        <ShowContent
                                            href={formState.media?.path}
                                            target='_blank'
                                            rel='noopener noreferrer'>
                                            <RemoveFileIcon className='fas fa-eye' />
                                        </ShowContent>
                                    </aside>
                                </FileMetaData>
                                </div>
                            </PreviewContainer>
                            </Col>
                        </Row>

                        <Row className="justify-content-between" style={{display: form?.status==="Open"? 'flex' : 'none' }}>
                            <Col  md={6}>
                                <button
                                    type="button"
                                    className="btn btn-success w-100 text-center font-size-16 btnHeight"
                                    onClick={() => SubmitHandler() }
                                    disabled={loading}
                                >
                                    Submit
                                </button>
                            </Col>
                            <Col md={6} className="d-flex justify-content-end">
                                <button
                                    onClick={()=> notSubmit()}
                                    className="btn btn-secondary w-100 text-center font-size-16 float-end btnHeight"
                                >
                                    Not Submit
                                </button>
                            </Col>
                        </Row>

                    </ModalBody>
                </Modal>
    )
}
const toCurrency = (number) => {
    const numberInt = parseInt(number)
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(numberInt);
}
export default ConfirmReceiptModal;